// ─── Plotted i18n ─────────────────────────────────────────────────────────────
// Screens covered: Profile, Home, Destinations, Calendar, Onboarding, Subscription, Map

const translations = {

  // ── Français ────────────────────────────────────────────────────────────────
  fr: {
    // Signature de marque. taglineAlt est une variante gardée en réserve :
    // elle existe dans les 4 langues mais n'est affichée nulle part.
    brand: {
      tagline:      'Une sélection, pas un moteur de recherche.',
      taglineShort: 'Une sélection, pas une recherche',
      taglineAlt:   'Arrêtez de chercher. Commencez à choisir.',
    },
    profile: {
      title:          'Mon profil',
      yourProfile:    'Votre profil',
      notFilled:      'Non renseigné',
      completion:     'Complétude du profil',
      completionLow:  'Complétez votre profil pour des recommandations précises',
      completionMid:  'Encore quelques infos pour finaliser',

      // hub sections
      personal:         'Informations personnelles',
      travelers:        'Voyageurs & départ',
      prefs:            'Préférences voyage',
      coTravel:         'Co-voyageur',

      // voyageurs
      me:               'Moi',
      coTravelersLabel: 'Co-voyageurs',
      paxTotal:         '{n} voyageur(s) au total',
      relation:         'Relation',
      addTraveler:      '+ Ajouter un voyageur',
      edit:             'Modifier',
      remove:           'Supprimer',
      relConjoint:      'Conjoint·e',
      relEnfant:        'Enfant',
      relAmi:           'Ami·e',
      relAutre:         'Autre',

      // field labels
      firstName:        'Prénom',
      lastName:         'Nom',
      email:            'Email',
      phone:            'Téléphone',
      street:           'Rue',
      postalCode:       'Code postal',
      city:             'Ville',
      country:          'Pays',
      region:           'Région / État',
      birthDate:        'Date de naissance',
      passportNumber:   'N° Passeport',
      passportExpiry:   "Date d'expiration",
      passportCountry:  'Pays émetteur',
      departureAirports:'Aéroport(s) de départ',
      lang:             'Langue',
      langNote:         'Par défaut celle de votre device',

      // placeholders
      phFirstName:      'Jean',
      phLastName:       'Dupont',
      phEmail:          'vous@exemple.com',
      phStreet:         '12 rue de la Paix',
      phPostal:         '75001',
      phCity:           'Paris',
      phCountry:        'France',
      phRegion:         'Toscane, CA…',
      phPassport:       'AB 123456',
      phDate:           'JJ / MM / AAAA',
      phAirportSearch:  'Paris, Lyon, Marseille…',

      // preference chip labels
      styleLabel:          'Style',
      groupLabel:          'Groupe',
      dailyBudgetLabel:    'Budget / jour / personne',
      flightServicesLabel: 'Services & options vol',
      hotelBudgetLabel:    'Budget hôtel / nuit',
      hotelKeywordsLabel:  'Mots-clés hôtel',
      phHotelKeywords:     'pet friendly, petit déjeuner inclus…',
      flightClassLabel:         'Classe vol',
      flightClassNote:          'Selon disponibilité',
      departureTimePrefLabel:   'Heure de départ',
      departureTimePrefNote:    'Soir J1 = vous partez le premier soir du slot · Matin J2 = vous partez le lendemain matin',

      // co-traveller
      phCoFirstName:  'Marie',
      phCoEmail:      'marie@exemple.com',
      shareTrip:      'Partager les infos de voyage',
      shareTripSub:   'Recevoir les mêmes emails de confirmation',

      // referral
      referralSection:  'Parrainage',
      referralLink:     'Ton lien de parrainage',
      referralCopy:     'Copier',
      referralCopied:   'Copié !',
      referralShare:    'Partager',
      referralStats:    '{n} ami(s) invité(s) · {w} semaine(s) Voyageur gagnée(s)',
      referralBonus:    '🎁 +2 semaines Voyageur pour toi et ton ami',
      referralHelp:     'Partagez Plotted avec vos amis pour débloquer un monde de destinations supplémentaires.',
      // share top n
      shareTopN:        'Partager mon Top 5',
      shareTopNCopied:  'Lien copié !',
      shareTopNBtn:     'Copier le lien',
      shareTopNCreating:'Création du lien…',
      // share modal
      shareModalTitle:  'Partager mes destinations',
      shareModalReady:  'Ta carte Plotted est prête\u00a0! ✨',
      shareModalReadyTrip: 'Ton partage est prêt\u00a0! ✈️',
      shareModalCount:  n => `${n} destination${n>1?'s':''} prioritaire${n>1?'s':''} · `,
      shareModalTotal:  n => `${n} au total`,
      shareModalShare:  'Partager',
      shareModalCopyLink: '🔗 Copier le lien',
      shareModalCopied: '✓ Lien copié !',
      // share view (public page)
      shareViewCta:         'Inscris-toi',
      shareViewCtaTrip:     'Carnet de voyage',
      shareViewExpired:     'Lien expiré ou invalide',
      shareViewCtaCard:     n => `${n} a déjà son Top`,
      shareViewCtaCardAnon: 'Et toi, c\u2019est quoi ton Top 5\u00a0?',
      shareViewCtaYou:      'Et toi\u00a0?',
      shareViewCtaBody:     'Plotted trouve tes meilleures destinations selon tes dates, ton budget et tes envies.',
      shareViewCtaBtn:      'Inscris-toi gratuitement →',
      shareViewCtaSub:      'Gratuit · Sans CB · 2 minutes',
      shareViewBucketList:  'Bucket list',
      shareViewTopNOf:      (n, name) => name ? `Top ${n} de ${name}` : `Mon Top ${n}`,
      shareViewFlights:     'Options de vol',
      shareViewFlight:      'Vol',
      shareViewHotel:       'Hôtel',
      shareViewTotal:       'Total séjour',
      shareViewDirect:      'Direct',
      shareViewStop:        n => `${n} escale${n>1?'s':''}`,
      shareViewDep:         'Départ',
      shareViewArr:         'Arrivée',
      shareViewEstimated:   'prix estimé',
      shareViewFreeCancel:  'annulation gratuite',
      shareViewHighlights:  'À voir absolument',
      shareViewHiddenGems:  'Secrets locaux',
      shareViewBars:        'Meilleurs bars',
      shareViewRestaurants: 'Restaurants',
      shareViewGuide:       'Guide',
      shareViewTripOf:      name => name ? `Voyage de ${name}` : 'Mon voyage',
      shareViewTripTo:      dest => dest ? `Voyage à ${dest}` : 'Mon voyage',
      shareViewSlotsOf:     name => name ? `Slots de ${name}` : 'Options de vol',
      shareViewFrom:        'à partir de',
      // infos pratiques
      shareViewPracticalTitle:  'Infos pratiques',
      shareViewNoteTitle:       'À noter',
      shareViewPhrasebookTitle: 'Lexique',
      shareViewLabelCurrency:   'Monnaie',
      shareViewLabelPhone:      'Indicatif',
      shareViewLabelElectricity:'Électricité',
      shareViewLabelLanguage:   'Langue',
      shareViewLabelTimezone:   'Fuseau',
      shareViewLabelWater:      'Eau robinet',
      shareViewLabelTipping:    'Pourboires',
      shareViewLabelHolidays:   'Jours fériés',
      shareViewLabelSales:      'Soldes',
      // itinerary
      shareViewItineraryTitle:  'Programme',
      shareViewDay:             n => `Jour ${n}`,
      shareViewMorning:         'Matin',
      shareViewLunch:           'Déjeuner',
      shareViewAfternoon:       'Après-midi',
      shareViewEvening:         'Soirée',
      shareViewDinner:          'Dîner',
      // social card
      socialCardTitle:  'Mon prochain voyage',
      socialCardShare:  'Partager',
      // account
      changePassword: 'Changer le mot de passe',
      settings:       'Paramètres',
      phCurrentPwd:   'Mot de passe actuel',
      phNewPwd:       'Nouveau mot de passe',
      phConfirmPwd:   'Confirmer le mot de passe',
      confirm:        'Confirmer',
      save:           'Enregistrer',
      signOut:        'Se déconnecter',
      deleteAccount:        'Supprimer mon compte',
      deleteAccountConfirm: 'Cette action est irréversible. Toutes vos données seront définitivement effacées.',
      deleteAccountBtn:     'Confirmer la suppression',
      deleteAccountCancel:  'Annuler',
      deleteAccountDone:    'Compte supprimé.',
      deleteAccountError:   'La suppression a échoué. Réessaie ou contacte le support.',

      // password feedback
      pwdEnterCurrent: 'Saisissez votre mot de passe actuel',
      pwdMin8:         'Minimum 8 caractères',
      pwdNoMatch:      'Les mots de passe ne correspondent pas',
      pwdWrongCurrent: 'Mot de passe actuel incorrect',
      pwdUpdated:      'Mot de passe mis à jour',

      // settings
      holidayCountry:     'Pays de référence · jours fériés et ponts',
      holidayCountryNote: 'Cliquez sur "↺ Slots auto" dans le Calendrier pour recalculer.',
      holidayCountryAuto: 'Par défaut : détecté depuis votre navigateur.',
      autoPrefix:         'Auto —',
      appLang:            "Langue de l'application",
      soon:               '(bientôt)',
      detectedLang:       'Langue détectée :',
      searchMode:         'Mode de recherche',
      flightOnly:         'Vol uniquement',
      flightAndHotel:     'Vol + hôtel',
      replayOnboarding:   'Revoir le tutoriel',
      about:              'À propos',

      // subscription management
      accountSection:  'Gestion de compte',
      planLabel:       'Plan actuel',
      subscribedOn:    'Souscrit le',
      renewalOn:       'Renouvellement',
      managePlan:      'Gérer mon abonnement',
      freePlanDesc:    'Gratuit',
    },

    auth: {
      forgotTitle:  'Mot de passe oublié',
      loginTitle:   'Bienvenue',
      signupTitle:  'Créer un compte',
      forgotSub:    'Saisis ton email pour recevoir un lien de réinitialisation',
      loginSub:     'Connecte-toi pour continuer ton aventure',
      signupSub:    'Rejoins Plotted et explore le monde',
      resetSent:    'Un lien de réinitialisation a été envoyé à ',
      checkEmail:   'Vérifie ton email pour confirmer ton compte.',
      phPassword:   'Mot de passe',
      forgotLink:   'Mot de passe oublié ?',
      sendLink:     'Envoyer le lien',
      signIn:       'Se connecter',
      signUp:       "S'inscrire",
      backToLogin:  '← Retour à la connexion',
      orWith:       'ou continuer avec',
      googleBtn:    'Continuer avec Google',
      magicBtn:     'Recevoir un lien magique',
      magicSent:    'Lien envoyé — vérifiez votre boîte mail.',
      noAccount:    'Pas de compte ?',
      haveAccount:  'Déjà un compte ?',
      terms:        "En continuant, vous acceptez nos Conditions d'utilisation",
    },

    common: {
      howItWorks: 'Comment ça marche ?',
      understood: 'Compris',
      cancel:     'Annuler',
      back:       '‹ Retour',
      night:      'nuit',
      nights:     'nuits',
    },
    nightpicker: {
      title:       'Durée du séjour',
      recommended: 'Recommandé : {min}–{max} nuits',
      generate:    'Valider',
    },
    itin: {
      header:      'Itinéraire',
      loading:     'Génération de votre itinéraire…',
      loadingHint: 'Cela prend ~10 secondes',
    },
    session: {
      takenOver:    'Session reprise ailleurs',
      takenOverSub: 'Vous avez ouvert Plotted dans un autre onglet ou fenêtre. Cette session est en pause.',
      resumeHere:   'Reprendre ici',
    },

    home: {
      traveller:      'voyageur',
      travellers:     'voyageurs',
      flightHotel:    'vol + hôtel',
      recalculate:    'Recalculer les prix',
      myDests:        n => `Mes ${n} destinations`,
      mySlots:        n => `Mes ${n} slots`,
      computing:      'Calcul des meilleurs prix…',
      loadingText:    'Plotted cherche vos meilleures options…',
      emptyPlan:      'Ajoute des destinations à ton plan et des dates pour voir le classement',
      emptyNoDest:    'Explorez la carte pour découvrir et ajouter des destinations',
      emptyCtaMap:    'Découvrir des destinations',
      emptyNoPlan:    'Ajoutez des destinations à votre plan pour voir votre classement',
      emptyCtaPlan:   'Mes destinations',
      emptyNoSlot:    'Pas de dates sélectionnées. Voulez-vous que j\'ajoute les ponts et jours fériés pour commencer ?',
      emptyCtaAutoSlot: 'Générer automatiquement',
      emptyCtaDest:   'Créez votre 1ère destination',
      emptyCtaSlot:   'Aller dans l\'agenda',
      showSlotBanner: 'Afficher le calendrier',
      emptyNoCompat:  (n) => `Aucune de tes destinations ne correspond à tes créneaux (max ${n} nuit${n>1?'s':''}). Allonge tes créneaux ou choisis des destinations plus proches.`,
      emptyCtaLonger: 'Modifier les créneaux',
      emptyCtaCloser: 'Modifier les destinations',
      groupWeekend:   'Escapade',
      groupCitybreak: 'Voyage',
      groupVoyage:    'Grand Tour',
      share:          'Partager',
      updatedNow:     'à l\'instant',
      updatedMins:    (n) => `il y a ${n} min`,
      updatedHours:   (n) => `il y a ${n}h`,
      updatedDays:    (n) => `il y a ${n}j`,
      geoBlockedTitle: 'Localisation non autorisée',
      geoBlockedMsg:   "Les durées minimales et le classement sont estimés depuis Paris. Pour des recommandations précises, définissez votre aéroport de départ.",
      geoBlockedCta:   'Définir mon aéroport de départ',
      noSlotForDest:  'Aucun slot compatible pour cette destination',
      noDestForSlot:  'Aucune destination compatible pour ce slot',
      noFlightEvent:  'Aucun vol trouvé pour cet événement. Vérifiez votre aéroport de départ dans le Profil.',
      helpText:       "Plotted associe vos destinations à vos disponibilités — ou l'inverse. Le classement tient compte de vos préférences de voyage. Pour les événements, on considère une arrivée jusqu'à 3 jours avant avec retour le lendemain.",
      shareCta:       n => `Partage ton Top ${n}`,
      shareCtaSub:    'Fais découvrir tes prochaines aventures',
      needsLongSlot:  'Créneau long requis',
      needsLongSlotSub: 'Ajouter un créneau long ou réduire les nuits min.',
      from:           'à partir de',
      arrival:        'Arrivée',
      estimated:      'Prix estimé',
    },

    dest: {
      title:        'Mes destinations',
      helpText:     "Construisez votre liste de rêves en cherchant par nom ou en explorant la carte. Plotted calcule les prix pour vos créneaux de voyage et classe les meilleures options pour vous. Pour commencer, nous avons ajouté trois destinations populaires.",
      emptyTitle:   'Aucune destination',
      emptySub:     "Explore la carte et ajoute les destinations et événements qui t'inspirent.",
      add:          'Ajouter',
      explore:      '🗺️ Explorer',
      filterAll:    'Toutes',
      filterCity:   'Cité',
      filterNature: 'Évasion',
      filterEvent:  "À l'affiche",
      subAll:       'Tous',
      loading:      'Chargement',
      activePlan:   'Plan actif',
      planEmpty:    'Sélectionne jusqu\'à {n} destinations pour le classement Top 5',
      place:        'lieu',
      places:       'lieux',
      addModalTitle:  'Ajouter une destination',
      addModalSearch: 'Ville, pays ou événement…',
      addModalHint:   'Tapez au moins 2 caractères — ville, pays ou événement.',
      addModalEmpty:  'Aucun résultat',
      addModalSearching:  'Recherche…',
      addModalClose:      'Fermer',
      addModalDoneN:      'Terminé · {n} ajoutée(s)',
      addModalDidYouMean: 'Aucune correspondance exacte. Vouliez-vous dire :',
      addModalAdding:     'Ajout…',
      addModalAddFailed:  "L'ajout a échoué. Réessaie.",
      addModalAdded:  '✓ Ajouté',
      planAdd:      '+ Plan',
      planIn:       '✓ Plan',
      planFull:     'Complet',
      noSlotTitle:  'Aucun créneau compatible dans le plan',
      noSlotBody:   (dest, nights) => `${dest} nécessite au moins ${nights} nuits — aucun créneau de votre plan ne correspond. Ajoutez un créneau plus long ou ajustez les nuits min.`,
      noSlotAdjust: 'Ajuster les nuits min',
      noSlotCreate: 'Créer un créneau',
    },

    cal: {
      title:       'Calendrier',
      helpText:    'Indiquez vos disponibilités de voyage — les ponts sont déjà inclus, à vous de les ajuster. Créez des créneaux courts pour un city-break, ou plus longs pour une aventure au bout du monde.',
      autoSlots:   '↺ Slots auto',
      slots:       'slots',
      nights:      'nuits',
      loading:     'Chargement des slots...',
      event:       'Événement',
      bridge:      'Pont',
      addSlot:          '+ Ajouter un slot',
      slotLimitReached: 'Limite de slots atteinte',
      chooseDep:   'Choisir la date de départ',
      chooseRet:   'Choisir la date de retour',
      reset:       'Réinitialiser',
      addThisSlot: 'Ajouter ce slot',
      editSlot:    'Modifier le slot',
      customSlot:  'Personnaliser le slot',
      selectDep:   'Sélectionne le départ',
      selectRet:   'Sélectionne le retour',
      delete:      '🗑 Supprimer',
      save:        'Enregistrer',
    },

    ob: {
      page0title: 'Du rêve au voyage. Sans escales inutiles.',
      page0sub:   '',
      labelCity:   'Vibrer',
      labelNature: 'Ressourcer',
      labelEvent:  "S'éclater",
      page1title: 'Épinglez vos destinations. C\'est tout.',
      page1sub:   '',
      page2title: 'Quand partez-vous ? Jours fériés et ponts inclus.',
      page2sub:   '',
      page3title: 'Vos dates. Vos destinations. Plotted.',
      page3sub:   '',
      calDays:    ['L','M','M','J','V','S','D'],
      calMonths:  ['JANVIER','FÉVRIER','MARS','AVRIL','MAI','JUIN','JUILLET','AOÛT','SEPTEMBRE','OCTOBRE','NOVEMBRE','DÉCEMBRE'],
      continue:   'Continuer →',
      letsGo:     "C'est parti !",
      skip:       'Passer',
    },

    trip: {
      yourSelection:  'Votre sélection',
      flight:         'Vol',
      hotel:          'Hôtel',
      co2offset:      'Compensation CO₂',
      bookNow:        'Réserver — €{total}',
      sort:           'Trier :',
      sortBest:       '⭐ Meilleur',
      sortPrice:      '💶 Prix',
      sortFastest:    '⚡ Plus rapide',
      sortEco:        '🌿 Éco',
      sortRating:     '🏅 Note',
      sortDistance:   '📍 Distance',
      flightsFound:   '{n} vols trouvés · {origin} → {city} · {date}',
      hotelsFound:    '{n} hôtels · {city} · {from} – {to} · {nights} nuits',
      belowAvg:       '↓ {pct}% sous la moyenne historique',
      historicAvg:    'Moyenne historique pour cette destination + dates :',
      yourSaving:     'Votre économie :',
      flightAnalysis: 'Analyse du vol sélectionné',
      hotelReview:    'Détail des notes de l\'hôtel sélectionné',
      co2footprint:   '🌿 Empreinte carbone',
      co2roundtrip:   '{co2}t CO₂ pour cet aller-retour',
      co2offsetCost:  'Compensation : €{cost} · reversé à des projets de reforestation certifiés',
      greener:        '{pct}% plus vert que la moyenne pour cette route',
      scorePrice:     'Prix',
      scoreDuration:  'Durée',
      scoreCo2:       'Efficacité CO₂',
      scoreComfort:   'Confort & options',
    },
    flight: {
      direct:     'DIRECT',
      stop:       '1 ESCALE',
      bagIncl:    '🧳 Bagage inclus',
      flexible:   '🔄 Flexible',
      seatsLeft:  '🔥 {n} places restantes',
      vsAvg:      '{n}% vs moyenne',
      lowcost:    'Low-cost',
      alliance:   'alliance',
      selected:   '✓ Vol sélectionné',
    },
    hotel: {
      perNight:    '/nuit',
      reviews:     'avis',
      fromCentre:  'km du centre',
      selected:    '✓ Hôtel sélectionné',
    },

    save: { failed: "Tes dernières modifications n'ont pas pu être enregistrées. Elles restent sur cet appareil — vérifie ta connexion." },
    sub: {
      mockNotice:     "Démonstration — aucun paiement n'est encaissé et aucune donnée bancaire n'est transmise.",
      back:           '← Retour',
      activated:      'Abonnement activé !',
      contactDetails: 'Coordonnées',
      paymentInfo:    'Informations de paiement',
      email:          'Email',
      expiry:         'MM / AA',
      cardHolder:     'Nom sur la carte',
      processing:     'Traitement en cours…',
      payAmount:      'Payer {amount}',
      perYear:        '/ an',
      perMonth:       '/ mois',
      planFree:      'Wanderer',
      planSilver:    'Voyageur',
      planGold:      'Explorateur',
      headline:      'En Wanderer, votre <b>Top 5</b> sur 5 destinations et 5 créneaux. Passez à Voyageur ou Explorateur pour aller plus loin.',
      tagline:       'Pour aller plus loin, choisissez votre formule :',
      monthly:       'Mensuel',
      annual:        'Annuel',
      perMonth:      '/ mois',
      perYear:       '/ an · ',
      subscribe:     "Je m'abonne",
      currentPlan:   'Plan actuel',
      activePlan:    '✓ Actif',
      downgradeLink: 'Revenir au plan <i>Wanderer</i>',
      silverFeats:   ['10 destinations', '10 créneaux calendrier', '10 itinéraires / mois'],
      goldFeats:     ['15 destinations', '15 créneaux calendrier', '15 itinéraires / mois'],
    },

    map: {
      typeVille:    'Cité',
      typeNature:   'Évasion',
      typeIle:      'Îles',
      typeCote:     'Côtes',
      typeEvent:    "À l'affiche",
      evtSport:     'Sport',
      evtMusic:     'Musique',
      evtCulture:   'Culture',
      evtNature:    'Nature',
      unknownEvent: 'Événement',

      contAmerique: 'Amérique',
      contEurope:   'Europe',
      contAfrique:  'Afrique',
      contMOrient:  'M.Orient',
      contAsie:     'Asie',
      contOceanie:  'Océanie',

      filterCity:   'Cité',
      filterNature: 'Évasion',
      filterEvent:  "À l'affiche",
      filterSel:    'Mes dest.',

      back:         'Retour',
      title:        'Explorer',
      loading:      'Chargement…',
      dest1:        'destination',
      destN:        'destinations',
      statusEvents: 'événements',

      inProgress:   'En cours',
      inDays:       'Dans {n}j',
      inMonths:     'Dans {n}mois',
      annualEvent:  '🔄 Événement annuel',

      eventAdded:   '✓ Événement ajouté',
      destAdded:    '✓ Destination ajoutée',
      addToEvents:  '+ Ajouter',
      addToDests:   '+ Ajouter',
      toast:        '✓ Ajouté à votre sélection',
      errorPrefix:  'Erreur : ',
    },

    downgrade: {
      destsTitle: 'Trop de destinations',
      slotsTitle: 'Trop de créneaux',
      removeN:    'Retirez encore {n}',
      remove:     'Retirer',
      confirm:    'Valider',
      autoTrim:   'Réduire automatiquement',
      helpText:   'Plotted limite automatiquement le nombre de combinaisons affichées pour rester fluide. Vous pouvez gérer cela vous-même, ou laisser Plotted s\'en charger — les options les plus anciennes seront supprimées en premier.',
    },

    guide: {
      highlights:   'À voir absolument',
      hiddenGems:   'Secrets locaux',
      bars:         'Meilleurs bars',
      restaurants:  'Restaurants',
      loading:      'Génération du guide…',
      by:           'Top 5 de',
      generatedBy:  'Généré par Plotted · vol + hôtel',
    },

    about: {
      title:       'À propos de Plotted',
      tagline:     'Parce que les plus beaux voyages commencent sur une carte.',
      p1:          "Plotted est né d'un constat simple : trouver le bon moment pour partir au meilleur prix prend un temps fou. Surveiller les vols, comparer les périodes, guetter les promotions… c'est presque un second métier.",
      p2:          "Tu rêves, tu pinnes, tu oublies. Plotted, lui, n'oublie pas. Il surveille, il compare, il t'alerte — et quand le moment est venu, tout est là, sur ta carte.",
      p3:          "Parce que les meilleures occasions ne durent pas. Un vol qui chute, une période creuse, une promo qui disparaît en 48h — sans outil dédié, on passe à côté. Toujours.",
      p4:          "Plotted comble ce vide. Ce n'est pas un comparateur de plus. Ce n'est pas une liste figée. C'est ta carte personnelle qui travaille en silence — et qui te parle quand ça compte vraiment.",
      p5:          "Tes destinations de rêve méritent mieux qu'un onglet oublié dans ton navigateur.",
      teamTitle:   'Les Plotters',
      teamIntro:   "Nous sommes cinq passionnés de voyages, convaincus qu'explorer le monde ne devrait pas être une affaire de budget ou de temps perdu à chercher.",
      m1role:      'Fondateur & Développeur',
      m1bio:       "Il a eu l'idée, il a écrit le code. Convaincu qu'une belle carte vaut mieux qu'un long discours.",
      m2role:      'Design & Expérience utilisateur',
      m2bio:       'Elle donne à Plotted son caractère visuel. Chaque écran est pensé pour que naviguer soit un plaisir.',
      m3role:      'Data & Prix',
      m3bio:       "Les bons prix ne préviennent pas. Lui, si. Wizard du pricing en ligne, FareHunter connaît les rouages des plateformes de voyage mieux que personne.",
      m4role:      'Communauté & Réseaux',
      m4bio:       "Toujours entre deux avions, elle fait le lien entre Plotted et ses utilisateurs. C'est elle qu'on entend sur les réseaux.",
      m5role:      'Contenu & Destinations',
      m5bio:       "Il sélectionne, documente et raconte chaque destination. Rien n'entre dans Plotted sans passer par lui.",
      contactTitle:'Parlons voyages',
      contactText: 'Une idée, une suggestion, une destination à recommander ? Je lis tous les messages.',
    },

    nav: {
      home:   'plotted',
      dest:   'Dest.',
      map:    'Carte',
      cal:    'Agenda',
      trips:  'Voyages',
      user:   'Profil',
    },

    splash: {
      tagline1: 'Vos rêves, notre veille.',
      tagline2: 'Parce que les meilleures occasions ne durent pas.',
      welcome:  'Heureux de te revoir',
    },
  },

  // ── English ─────────────────────────────────────────────────────────────────
  en: {
    brand: {
      tagline:      'A shortlist, not a search bar.',
      taglineShort: 'A shortlist, not a search',
      taglineAlt:   'Stop searching. Start choosing.',
    },
    profile: {
      title:          'My profile',
      yourProfile:    'Your profile',
      notFilled:      'Not provided',
      completion:     'Profile completion',
      completionLow:  'Complete your profile for accurate recommendations',
      completionMid:  'A few more details to finish',

      personal:         'Personal information',
      travelers:        'Travellers & departure',
      prefs:            'Travel preferences',
      coTravel:         'Co-traveller',

      me:               'Me',
      coTravelersLabel: 'Co-travellers',
      paxTotal:         '{n} traveller(s) total',
      relation:         'Relationship',
      addTraveler:      '+ Add traveller',
      edit:             'Edit',
      remove:           'Remove',
      relConjoint:      'Partner',
      relEnfant:        'Child',
      relAmi:           'Friend',
      relAutre:         'Other',

      firstName:        'First name',
      lastName:         'Last name',
      email:            'Email',
      phone:            'Phone',
      street:           'Street',
      postalCode:       'Postal code',
      city:             'City',
      country:          'Country',
      region:           'Region / State',
      birthDate:        'Date of birth',
      passportNumber:   'Passport no.',
      passportExpiry:   'Expiry date',
      passportCountry:  'Issuing country',
      departureAirports:'Departure airport(s)',
      lang:             'Language',
      langNote:         'Default is your device language',

      phFirstName:      'John',
      phLastName:       'Smith',
      phEmail:          'you@example.com',
      phStreet:         '12 Peace Street',
      phPostal:         'SW1A 1AA',
      phCity:           'London',
      phCountry:        'United Kingdom',
      phRegion:         'England, CA…',
      phPassport:       'AB 123456',
      phDate:           'DD / MM / YYYY',
      phAirportSearch:  'London, Manchester, Edinburgh…',

      styleLabel:          'Style',
      groupLabel:          'Group',
      dailyBudgetLabel:    'Budget / day / person',
      flightServicesLabel: 'Flight services & options',
      hotelBudgetLabel:    'Hotel budget / night',
      hotelKeywordsLabel:  'Hotel keywords',
      phHotelKeywords:     'pet friendly, breakfast included…',
      flightClassLabel:         'Flight class',
      flightClassNote:          'Subject to availability',
      departureTimePrefLabel:   'Departure time',
      departureTimePrefNote:    'Evening J1 = you leave on the first evening of the slot · Morning J2 = you leave the following morning',

      phCoFirstName:  'Mary',
      phCoEmail:      'mary@example.com',
      shareTrip:      'Share travel info',
      shareTripSub:   'Receive the same confirmation emails',

      referralSection:  'Referral',
      referralLink:     'Your referral link',
      referralCopy:     'Copy',
      referralCopied:   'Copied!',
      referralShare:    'Share',
      referralStats:    '{n} friend(s) invited · {w} Traveler week(s) earned',
      referralBonus:    '🎁 +2 Traveler weeks for you and your friend',
      referralHelp:     'Share Plotted with your friends and unlock a world of new destinations.',
      shareTopN:        'Share my Top 5',
      shareTopNCopied:  'Link copied!',
      shareTopNBtn:     'Copy link',
      shareTopNCreating:'Creating link…',
      // share modal
      shareModalTitle:  'Share my destinations',
      shareModalReady:  'Your Plotted card is ready! ✨',
      shareModalReadyTrip: 'Your share is ready! ✈️',
      shareModalCount:  n => `${n} priority destination${n>1?'s':''} · `,
      shareModalTotal:  n => `${n} total`,
      shareModalShare:  'Share',
      shareModalCopyLink: '🔗 Copy link',
      shareModalCopied: '✓ Link copied!',
      // share view (public page)
      shareViewCta:         'Sign up',
      shareViewCtaTrip:     'Travel journal',
      shareViewExpired:     'Link expired or invalid',
      shareViewCtaCard:     n => `${n} already has their Top`,
      shareViewCtaCardAnon: 'What\u2019s your Top 5?',
      shareViewCtaYou:      'And you?',
      shareViewCtaBody:     'Plotted finds your best destinations based on your dates, budget and preferences.',
      shareViewCtaBtn:      'Sign up for free →',
      shareViewCtaSub:      'Free · No credit card · 2 minutes',
      shareViewBucketList:  'Bucket list',
      shareViewTopNOf:      (n, name) => name ? `${name}'s Top ${n}` : `My Top ${n}`,
      shareViewFlights:     'Flight options',
      shareViewFlight:      'Flight',
      shareViewHotel:       'Hotel',
      shareViewTotal:       'Total stay',
      shareViewDirect:      'Direct',
      shareViewStop:        n => `${n} stop${n>1?'s':''}`,
      shareViewDep:         'Departure',
      shareViewArr:         'Arrival',
      shareViewEstimated:   'estimated price',
      shareViewFreeCancel:  'free cancellation',
      shareViewHighlights:  'Must-sees',
      shareViewHiddenGems:  'Local secrets',
      shareViewBars:        'Best bars',
      shareViewRestaurants: 'Restaurants',
      shareViewGuide:       'Guide',
      shareViewTripOf:      name => name ? `${name}'s trip` : 'My trip',
      shareViewTripTo:      dest => dest ? `Trip to ${dest}` : 'My trip',
      shareViewSlotsOf:     name => name ? `${name}'s flight options` : 'Flight options',
      shareViewFrom:        'from',
      shareViewPracticalTitle:  'Practical info',
      shareViewNoteTitle:       'Note',
      shareViewPhrasebookTitle: 'Phrasebook',
      shareViewLabelCurrency:   'Currency',
      shareViewLabelPhone:      'Phone',
      shareViewLabelElectricity:'Electricity',
      shareViewLabelLanguage:   'Language',
      shareViewLabelTimezone:   'Timezone',
      shareViewLabelWater:      'Tap water',
      shareViewLabelTipping:    'Tipping',
      shareViewLabelHolidays:   'Public holidays',
      shareViewLabelSales:      'Sales',
      shareViewItineraryTitle:  'Itinerary',
      shareViewDay:             n => `Day ${n}`,
      shareViewMorning:         'Morning',
      shareViewLunch:           'Lunch',
      shareViewAfternoon:       'Afternoon',
      shareViewEvening:         'Evening',
      shareViewDinner:          'Dinner',
      socialCardTitle:  'My next trip',
      socialCardShare:  'Share',
      changePassword: 'Change password',
      settings:       'Settings',
      phCurrentPwd:   'Current password',
      phNewPwd:       'New password',
      phConfirmPwd:   'Confirm password',
      confirm:        'Confirm',
      save:           'Save',
      signOut:        'Sign out',
      deleteAccount:        'Delete my account',
      deleteAccountConfirm: 'This action is irreversible. All your data will be permanently deleted.',
      deleteAccountBtn:     'Confirm deletion',
      deleteAccountCancel:  'Cancel',
      deleteAccountDone:    'Account deleted.',
      deleteAccountError:   'Deletion failed. Try again or contact support.',

      pwdEnterCurrent: 'Enter your current password',
      pwdMin8:         'Minimum 8 characters',
      pwdNoMatch:      'Passwords do not match',
      pwdWrongCurrent: 'Incorrect current password',
      pwdUpdated:      'Password updated',

      holidayCountry:     'Reference country · public holidays',
      holidayCountryNote: 'Click "↺ Auto slots" in Calendar to recalculate.',
      holidayCountryAuto: 'Default: detected from your browser.',
      autoPrefix:         'Auto —',
      appLang:            'App language',
      soon:               '(soon)',
      detectedLang:       'Detected language:',
      searchMode:         'Search mode',
      flightOnly:         'Flight only',
      flightAndHotel:     'Flight + hotel',
      replayOnboarding:   'Replay tutorial',
      about:              'About',

      // subscription management
      accountSection:  'Account',
      planLabel:       'Current plan',
      subscribedOn:    'Subscribed on',
      renewalOn:       'Renewal',
      managePlan:      'Manage subscription',
      freePlanDesc:    'Free',
    },

    auth: {
      forgotTitle:  'Forgot password',
      loginTitle:   'Welcome back',
      signupTitle:  'Create account',
      forgotSub:    'Enter your email to receive a reset link',
      loginSub:     'Sign in to continue your adventure',
      signupSub:    'Join Plotted and explore the world',
      resetSent:    'A reset link has been sent to ',
      checkEmail:   'Check your email to confirm your account.',
      phPassword:   'Password',
      forgotLink:   'Forgot password?',
      sendLink:     'Send link',
      signIn:       'Sign in',
      signUp:       'Sign up',
      backToLogin:  '← Back to sign in',
      orWith:       'or continue with',
      googleBtn:    'Continue with Google',
      magicBtn:     'Send me a magic link',
      magicSent:    'Link sent — check your inbox.',
      noAccount:    'No account?',
      haveAccount:  'Already have an account?',
      terms:        'By continuing, you accept our Terms of Use',
    },

    common: {
      howItWorks: 'How does it work?',
      understood: 'Got it',
      cancel:     'Cancel',
      back:       '‹ Back',
      night:      'night',
      nights:     'nights',
    },
    nightpicker: {
      title:       'Stay duration',
      recommended: 'Recommended: {min}–{max} nights',
      generate:    'Confirm',
    },
    itin: {
      header:      'Itinerary',
      loading:     'Generating your itinerary…',
      loadingHint: 'This takes ~10 seconds',
    },
    session: {
      takenOver:    'Session resumed elsewhere',
      takenOverSub: 'You opened Plotted in another tab or window. This session is paused.',
      resumeHere:   'Resume here',
    },

    home: {
      traveller:      'traveller',
      travellers:     'travellers',
      flightHotel:    'flight + hotel',
      recalculate:    'Recalculate prices',
      myDests:        n => `My ${n} destinations`,
      mySlots:        n => `My ${n} slots`,
      computing:      'Computing best prices…',
      loadingText:    'Plotted is finding your best options…',
      emptyPlan:      'Add destinations to your plan and dates to see the ranking',
      emptyNoDest:    'Explore the map to discover and add destinations',
      emptyCtaMap:    'Discover destinations',
      emptyNoPlan:    'Add destinations to your plan to see your ranking',
      emptyCtaPlan:   'My destinations',
      emptyNoSlot:    'No dates selected. Want me to add bank holidays and bridge days to get started?',
      emptyCtaAutoSlot: 'Generate automatically',
      emptyCtaDest:   'Add your first destination',
      emptyCtaSlot:   'Go to calendar',
      showSlotBanner: 'Show calendar',
      emptyNoCompat:  (n) => `None of your destinations match your slots (max ${n} night${n>1?'s':''}). Try longer slots or closer destinations.`,
      emptyCtaLonger: 'Edit slots',
      emptyCtaCloser: 'Edit destinations',
      groupWeekend:   'Getaway',
      groupCitybreak: 'Journey',
      groupVoyage:    'Grand Tour',
      share:          'Share',
      updatedNow:     'just now',
      updatedMins:    (n) => `${n} min ago`,
      updatedHours:   (n) => `${n}h ago`,
      updatedDays:    (n) => `${n}d ago`,
      geoBlockedTitle: 'Location not allowed',
      geoBlockedMsg:   'Minimum stay durations and rankings are estimated from Paris. Set your departure airport for accurate recommendations.',
      geoBlockedCta:   'Set my departure airport',
      noSlotForDest:  'No compatible slot for this destination',
      noDestForSlot:  'No compatible destination for this slot',
      noFlightEvent:  'No flight found for this event. Check your departure airport in Profile.',
      helpText:       "Plotted matches your destinations with your available dates — or the other way around. Rankings factor in your travel preferences. For events, we consider arriving up to 3 days before and leaving the day after.",
      shareCta:       n => `Share your Top ${n}`,
      shareCtaSub:    'Let your friends discover what\'s coming next',
      needsLongSlot:  'Long slot required',
      needsLongSlotSub: 'Add a long slot or reduce min. nights.',
      from:           'from',
      arrival:        'Arriving',
      estimated:      'Est. price',
    },

    dest: {
      title:        'My destinations',
      helpText:     'Build your bucket list by searching by name or browsing the map. Plotted calculates prices for your travel windows and ranks the best options for you. To get you started, we\'ve added three popular destinations.',
      emptyTitle:   'No destination',
      emptySub:     'Explore the map and add the destinations and events that inspire you.',
      add:          'Add',
      explore:      '🗺️ Explore',
      filterAll:    'All',
      filterCity:   'City',
      filterNature: 'Escape',
      filterEvent:  'Featured',
      subAll:       'All',
      loading:      'Loading',
      activePlan:   'Active plan',
      planEmpty:    'Select up to {n} destinations for the Top 5 ranking',
      place:        'dream',
      places:       'dreams',
      addModalTitle:  'Add a destination',
      addModalSearch: 'City, country or event…',
      addModalHint:   'Type at least 2 characters — city, country or event.',
      addModalEmpty:  'No results',
      addModalSearching:  'Searching…',
      addModalClose:      'Close',
      addModalDoneN:      'Done · {n} added',
      addModalDidYouMean: 'No exact match. Did you mean:',
      addModalAdding:     'Adding…',
      addModalAddFailed:  'Could not add it. Try again.',
      addModalAdded:  '✓ Added',
      planAdd:      '+ Plan',
      planIn:       '✓ Plan',
      planFull:     'Full',
      noSlotTitle:  'No compatible slot in your plan',
      noSlotBody:   (dest, nights) => `${dest} requires at least ${nights} nights — no slot in your plan matches. Add a longer slot or adjust the min nights.`,
      noSlotAdjust: 'Adjust min nights',
      noSlotCreate: 'Create a slot',
    },

    cal: {
      title:       'Calendar',
      helpText:    'Set your potential travel windows — public holidays and long weekends are already included, then adjust as needed. Add short slots for a city break, or longer ones for a far-flung adventure.',
      autoSlots:   '↺ Auto slots',
      slots:       'slots',
      nights:      'nights',
      loading:     'Loading slots...',
      event:       'Event',
      bridge:      'Bridge',
      addSlot:          '+ Add a slot',
      slotLimitReached: 'Slot limit reached',
      chooseDep:   'Choose departure date',
      chooseRet:   'Choose return date',
      reset:       'Reset',
      addThisSlot: 'Add this slot',
      editSlot:    'Edit slot',
      customSlot:  'Customise slot',
      selectDep:   'Select departure',
      selectRet:   'Select return',
      delete:      '🗑 Delete',
      save:        'Save',
    },

    ob: {
      page0title: 'Inspiration to destination. Non stop.',
      page0sub:   '',
      labelCity:   'Pulse',
      labelNature: 'Rewild',
      labelEvent:  'Unleash',
      page1title: 'Pin your dream destinations. Once.',
      page1sub:   '',
      page2title: 'Pick your travel windows. Public holidays included.',
      page2sub:   '',
      page3title: 'Your dates. Your destinations. Plotted.',
      page3sub:   '',
      calDays:    ['M','T','W','T','F','S','S'],
      calMonths:  ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER'],
      continue:   'Continue →',
      letsGo:     "Let's go!",
      skip:       'Skip',
    },

    trip: {
      yourSelection:  'Your selection',
      flight:         'Flight',
      hotel:          'Hotel',
      co2offset:      'CO₂ offset',
      bookNow:        'Book now — €{total}',
      sort:           'Sort:',
      sortBest:       '⭐ Best',
      sortPrice:      '💶 Price',
      sortFastest:    '⚡ Fastest',
      sortEco:        '🌿 Eco',
      sortRating:     '🏅 Rating',
      sortDistance:   '📍 Distance',
      flightsFound:   '{n} flights found · {origin} → {city} · {date}',
      hotelsFound:    '{n} hotels · {city} · {from} – {to} · {nights} nights',
      belowAvg:       '↓ {pct}% below historic average',
      historicAvg:    'Historic avg for this destination + dates:',
      yourSaving:     'Your saving:',
      flightAnalysis: 'Selected flight analysis',
      hotelReview:    'Selected hotel review breakdown',
      co2footprint:   '🌿 Carbon footprint',
      co2roundtrip:   '{co2}t CO₂ for this round trip',
      co2offsetCost:  'Offset cost: €{cost} · donated to verified reforestation',
      greener:        '{pct}% greener than average for this route',
      scorePrice:     'Price',
      scoreDuration:  'Duration',
      scoreCo2:       'CO₂ efficiency',
      scoreComfort:   'Comfort & extras',
    },
    flight: {
      direct:     'DIRECT',
      stop:       '1 STOP',
      bagIncl:    '🧳 Bag incl.',
      flexible:   '🔄 Flexible',
      seatsLeft:  '🔥 {n} seats left',
      vsAvg:      '{n}% vs avg',
      lowcost:    'Low-cost',
      alliance:   'alliance',
      selected:   '✓ Flight selected',
    },
    hotel: {
      perNight:    '/night',
      reviews:     'reviews',
      fromCentre:  'km from centre',
      selected:    '✓ Hotel selected',
    },

    save: { failed: 'Your latest changes could not be saved. They are kept on this device — check your connection.' },
    sub: {
      mockNotice:     'Demo — no payment is taken and no card details are sent anywhere.',
      back:           '← Back',
      activated:      'Subscription activated!',
      contactDetails: 'Contact details',
      paymentInfo:    'Payment information',
      email:          'Email',
      expiry:         'MM / YY',
      cardHolder:     'Name on card',
      processing:     'Processing…',
      payAmount:      'Pay {amount}',
      perYear:        '/ year',
      perMonth:       '/ month',
      planFree:    'Wanderer',
      planSilver:  'Traveler',
      planGold:    'Explorer',
      headline:    'Wanderer plan: <b>Top 5</b> across 5 destinations and 5 slots. Upgrade to unlock more.',
      tagline:     'Go further — choose your plan:',
      monthly:     'Monthly',
      annual:      'Annual',
      perMonth:    '/ month',
      perYear:     '/ year · ',
      subscribe:   'Subscribe',
      currentPlan: 'Current plan',
      activePlan:  '✓ Active',
      downgradeLink: 'Switch to <i>Wanderer</i> plan',
      silverFeats: ['10 destinations', '10 calendar slots', '10 itineraries / month'],
      goldFeats:   ['15 destinations', '15 calendar slots', '15 itineraries / month'],
    },

    map: {
      typeVille:    'City',
      typeNature:   'Nature',
      typeIle:      'Islands',
      typeCote:     'Coasts',
      typeEvent:    'Featured',
      evtSport:     'Sport',
      evtMusic:     'Music',
      evtCulture:   'Culture',
      evtNature:    'Nature',
      unknownEvent: 'Event',

      contAmerique: 'Americas',
      contEurope:   'Europe',
      contAfrique:  'Africa',
      contMOrient:  'M.East',
      contAsie:     'Asia',
      contOceanie:  'Oceania',

      filterCity:   'City',
      filterNature: 'Escape',
      filterEvent:  'Featured',
      filterSel:    'My dest.',

      back:         'Back',
      title:        'Explore',
      loading:      'Loading…',
      dest1:        'destination',
      destN:        'destinations',
      statusEvents: 'events',

      inProgress:   'Ongoing',
      inDays:       'In {n}d',
      inMonths:     'In {n}mo',
      annualEvent:  '🔄 Annual event',

      eventAdded:   '✓ Event added',
      destAdded:    '✓ Destination added',
      addToEvents:  '+ Add',
      addToDests:   '+ Add',
      toast:        '✓ Added to your selection',
      errorPrefix:  'Error: ',
    },

    downgrade: {
      destsTitle: 'Too many destinations',
      slotsTitle: 'Too many slots',
      removeN:    'Remove {n} more',
      remove:     'Remove',
      confirm:    'Confirm',
      autoTrim:   'Auto-reduce',
      helpText:   'Plotted automatically limits the number of displayed combinations to keep things running smoothly. You can manage this yourself, or let Plotted handle it — the oldest options will be removed first.',
    },

    guide: {
      highlights:   'Must-see',
      hiddenGems:   'Hidden gems',
      bars:         'Best bars',
      restaurants:  'Restaurants',
      loading:      'Generating guide…',
      by:           'Top 5 by',
      generatedBy:  'Powered by Plotted · flight + hotel',
    },

    about: {
      title:       'About Plotted',
      tagline:     'Because the best journeys start on a map.',
      p1:          "Plotted was born from a simple observation: finding the right time to travel at the best price takes forever. Tracking flights, comparing periods, watching for deals… it's almost a second job.",
      p2:          "You dream, you pin, you forget. Plotted doesn't forget. It watches, compares, alerts you — and when the time comes, everything is there, on your map.",
      p3:          "Because the best deals don't last. A flight that drops, a quiet period, a promo gone in 48h — without a dedicated tool, you always miss them.",
      p4:          "Plotted fills that gap. Not another comparison site. Not a static list. Your personal map that works in silence — and speaks up when it really matters.",
      p5:          "Your dream destinations deserve better than a forgotten tab in your browser.",
      teamTitle:   'The Plotters',
      teamIntro:   "We are five travel enthusiasts, convinced that exploring the world shouldn't be a matter of budget or wasted time searching.",
      m1role:      'Founder & Developer',
      m1bio:       'He had the idea, he wrote the code. Convinced that a beautiful map beats a long speech.',
      m2role:      'Design & User Experience',
      m2bio:       'She gives Plotted its visual character. Every screen is designed so that navigating is a pleasure.',
      m3role:      'Data & Pricing',
      m3bio:       "Good prices don't give warnings. He does. A wizard of online pricing, FareHunter knows the mechanics of travel platforms better than anyone.",
      m4role:      'Community & Social Media',
      m4bio:       "Always between two flights, she connects Plotted with its users. She's the one you hear on social media.",
      m5role:      'Content & Destinations',
      m5bio:       'He selects, documents and tells the story of every destination. Nothing enters Plotted without going through him.',
      contactTitle:'Let\'s talk travel',
      contactText: 'An idea, a suggestion, a destination to recommend? I read every message.',
    },

    nav: {
      home:   'plotted',
      dest:   'Dest.',
      map:    'Map',
      cal:    'Schedule',
      trips:  'Trips',
      user:   'Profile',
    },

    splash: {
      tagline1: 'Your dreams, our watch.',
      tagline2: 'Because the best deals don\'t last.',
      welcome:  'Welcome back',
    },
  },

  // ── Español ─────────────────────────────────────────────────────────────────
  es: {
    brand: {
      tagline:      'Una selección, no un buscador.',
      taglineShort: 'Una selección, no un buscador',
      taglineAlt:   'Deja de buscar. Empieza a elegir.',
    },
    profile: {
      title:          'Mi perfil',
      yourProfile:    'Tu perfil',
      notFilled:      'No indicado',
      completion:     'Completitud del perfil',
      completionLow:  'Completa tu perfil para recomendaciones precisas',
      completionMid:  'Algunos datos más para finalizar',

      personal:         'Información personal',
      travelers:        'Viajeros & salida',
      prefs:            'Preferencias de viaje',
      coTravel:         'Acompañante',

      me:               'Yo',
      coTravelersLabel: 'Acompañantes',
      paxTotal:         '{n} viajero(s) en total',
      relation:         'Relación',
      addTraveler:      '+ Agregar viajero',
      edit:             'Editar',
      remove:           'Eliminar',
      relConjoint:      'Pareja',
      relEnfant:        'Hijo/a',
      relAmi:           'Amigo/a',
      relAutre:         'Otro',

      firstName:        'Nombre',
      lastName:         'Apellido',
      email:            'Email',
      phone:            'Teléfono',
      street:           'Calle',
      postalCode:       'Código postal',
      city:             'Ciudad',
      country:          'País',
      region:           'Región / Estado',
      birthDate:        'Fecha de nacimiento',
      passportNumber:   'N° Pasaporte',
      passportExpiry:   'Fecha de caducidad',
      passportCountry:  'País emisor',
      departureAirports:'Aeropuerto(s) de salida',
      lang:             'Idioma',
      langNote:         'Por defecto la de tu dispositivo',

      phFirstName:      'Carlos',
      phLastName:       'García',
      phEmail:          'tú@ejemplo.com',
      phStreet:         'Calle de la Paz 12',
      phPostal:         '28001',
      phCity:           'Madrid',
      phCountry:        'España',
      phRegion:         'Cataluña, CA…',
      phPassport:       'AB 123456',
      phDate:           'DD / MM / AAAA',
      phAirportSearch:  'Madrid, Barcelona, Sevilla…',

      styleLabel:          'Estilo',
      groupLabel:          'Grupo',
      dailyBudgetLabel:    'Presupuesto / día / persona',
      flightServicesLabel: 'Servicios de vuelo',
      hotelBudgetLabel:    'Presupuesto hotel / noche',
      hotelKeywordsLabel:  'Palabras clave hotel',
      phHotelKeywords:     'admite mascotas, desayuno incluido…',
      flightClassLabel:         'Clase de vuelo',
      flightClassNote:          'Según disponibilidad',
      departureTimePrefLabel:   'Hora de salida',
      departureTimePrefNote:    'Tarde J1 = sales la primera tarde del slot · Mañana J2 = sales a la mañana siguiente',

      phCoFirstName:  'María',
      phCoEmail:      'maria@ejemplo.com',
      shareTrip:      'Compartir info del viaje',
      shareTripSub:   'Recibir los mismos emails de confirmación',

      referralSection:  'Referidos',
      referralLink:     'Tu enlace de referido',
      referralCopy:     'Copiar',
      referralCopied:   '¡Copiado!',
      referralShare:    'Compartir',
      referralStats:    '{n} amigo(s) invitado(s) · {w} semana(s) Viajero ganada(s)',
      referralBonus:    '🎁 +2 semanas Viajero para ti y tu amigo',
      referralHelp:     'Comparte Plotted con tus amigos y desbloquea un mundo de nuevos destinos.',
      shareTopN:        'Compartir mi Top 5',
      shareTopNCopied:  '¡Enlace copiado!',
      shareTopNBtn:     'Copiar enlace',
      shareTopNCreating:'Creando enlace…',
      // share modal
      shareModalTitle:  'Compartir mis destinos',
      shareModalReady:  '¡Tu carta Plotted está lista! ✨',
      shareModalReadyTrip: '¡Tu enlace está listo! ✈️',
      shareModalCount:  n => `${n} destino${n>1?'s':''} prioritario${n>1?'s':''} · `,
      shareModalTotal:  n => `${n} en total`,
      shareModalShare:  'Compartir',
      shareModalCopyLink: '🔗 Copiar enlace',
      shareModalCopied: '✓ ¡Enlace copiado!',
      // share view (public page)
      shareViewCta:         'Regístrate',
      shareViewCtaTrip:     'Diario de viaje',
      shareViewExpired:     'Enlace expirado o inválido',
      shareViewCtaCard:     n => `${n} ya tiene su Top`,
      shareViewCtaCardAnon: '¿Cuál es tu Top 5?',
      shareViewCtaYou:      '¿Y tú?',
      shareViewCtaBody:     'Plotted encuentra tus mejores destinos según tus fechas, presupuesto y preferencias.',
      shareViewCtaBtn:      'Regístrate gratis →',
      shareViewCtaSub:      'Gratis · Sin tarjeta · 2 minutos',
      shareViewBucketList:  'Bucket list',
      shareViewTopNOf:      (n, name) => name ? `Top ${n} de ${name}` : `Mi Top ${n}`,
      shareViewFlights:     'Opciones de vuelo',
      shareViewFlight:      'Vuelo',
      shareViewHotel:       'Hotel',
      shareViewTotal:       'Total estancia',
      shareViewDirect:      'Directo',
      shareViewStop:        n => `${n} escala${n>1?'s':''}`,
      shareViewDep:         'Salida',
      shareViewArr:         'Llegada',
      shareViewEstimated:   'precio estimado',
      shareViewFreeCancel:  'cancelación gratuita',
      shareViewHighlights:  'Imprescindibles',
      shareViewHiddenGems:  'Secretos locales',
      shareViewBars:        'Mejores bares',
      shareViewRestaurants: 'Restaurantes',
      shareViewGuide:       'Guía',
      shareViewTripOf:      name => name ? `Viaje de ${name}` : 'Mi viaje',
      shareViewTripTo:      dest => dest ? `Viaje a ${dest}` : 'Mi viaje',
      shareViewSlotsOf:     name => name ? `Vuelos de ${name}` : 'Opciones de vuelo',
      shareViewFrom:        'desde',
      shareViewPracticalTitle:  'Información práctica',
      shareViewNoteTitle:       'Nota',
      shareViewPhrasebookTitle: 'Léxico',
      shareViewLabelCurrency:   'Moneda',
      shareViewLabelPhone:      'Indicativo',
      shareViewLabelElectricity:'Electricidad',
      shareViewLabelLanguage:   'Idioma',
      shareViewLabelTimezone:   'Zona horaria',
      shareViewLabelWater:      'Agua del grifo',
      shareViewLabelTipping:    'Propinas',
      shareViewLabelHolidays:   'Festivos',
      shareViewLabelSales:      'Rebajas',
      shareViewItineraryTitle:  'Itinerario',
      shareViewDay:             n => `Día ${n}`,
      shareViewMorning:         'Mañana',
      shareViewLunch:           'Almuerzo',
      shareViewAfternoon:       'Tarde',
      shareViewEvening:         'Noche',
      shareViewDinner:          'Cena',
      socialCardTitle:  'Mi próximo viaje',
      socialCardShare:  'Compartir',
      changePassword: 'Cambiar contraseña',
      settings:       'Ajustes',
      phCurrentPwd:   'Contraseña actual',
      phNewPwd:       'Nueva contraseña',
      phConfirmPwd:   'Confirmar contraseña',
      confirm:        'Confirmar',
      save:           'Guardar',
      signOut:        'Cerrar sesión',
      deleteAccount:        'Eliminar mi cuenta',
      deleteAccountConfirm: 'Esta acción es irreversible. Todos sus datos serán eliminados permanentemente.',
      deleteAccountBtn:     'Confirmar eliminación',
      deleteAccountCancel:  'Cancelar',
      deleteAccountDone:    'Cuenta eliminada.',
      deleteAccountError:   'No se pudo eliminar. Inténtalo de nuevo o contacta con soporte.',

      pwdEnterCurrent: 'Introduce tu contraseña actual',
      pwdMin8:         'Mínimo 8 caracteres',
      pwdNoMatch:      'Las contraseñas no coinciden',
      pwdWrongCurrent: 'Contraseña actual incorrecta',
      pwdUpdated:      'Contraseña actualizada',

      holidayCountry:     'País de referencia · festivos y puentes',
      holidayCountryNote: 'Haz clic en "↺ Slots auto" en el Calendario para recalcular.',
      holidayCountryAuto: 'Por defecto: detectado desde tu navegador.',
      autoPrefix:         'Auto —',
      appLang:            'Idioma de la app',
      soon:               '(pronto)',
      detectedLang:       'Idioma detectado:',
      searchMode:         'Modo de búsqueda',
      flightOnly:         'Solo vuelo',
      flightAndHotel:     'Vuelo + hotel',
      replayOnboarding:   'Ver tutorial de nuevo',
      about:              'Acerca de',

      // subscription management
      accountSection:  'Cuenta',
      planLabel:       'Plan actual',
      subscribedOn:    'Suscrito el',
      renewalOn:       'Renovación',
      managePlan:      'Gestionar suscripción',
      freePlanDesc:    'Gratuito',
    },

    auth: {
      forgotTitle:  'Contraseña olvidada',
      loginTitle:   'Bienvenido',
      signupTitle:  'Crear cuenta',
      forgotSub:    'Introduce tu email para recibir un enlace de restablecimiento',
      loginSub:     'Inicia sesión para continuar tu aventura',
      signupSub:    'Únete a Plotted y explora el mundo',
      resetSent:    'Se ha enviado un enlace de restablecimiento a ',
      checkEmail:   'Comprueba tu email para confirmar tu cuenta.',
      phPassword:   'Contraseña',
      forgotLink:   '¿Contraseña olvidada?',
      sendLink:     'Enviar enlace',
      signIn:       'Iniciar sesión',
      signUp:       'Registrarse',
      backToLogin:  '← Volver al inicio de sesión',
      orWith:       'o continuar con',
      googleBtn:    'Continuar con Google',
      magicBtn:     'Envíame un enlace mágico',
      magicSent:    'Enlace enviado — revisa tu correo.',
      noAccount:    '¿Sin cuenta?',
      haveAccount:  '¿Ya tienes cuenta?',
      terms:        'Al continuar, aceptas nuestros Términos de uso',
    },

    common: {
      howItWorks: '¿Cómo funciona?',
      understood: 'Entendido',
      cancel:     'Cancelar',
      back:       '‹ Volver',
      night:      'noche',
      nights:     'noches',
    },
    nightpicker: {
      title:       'Duración de la estancia',
      recommended: 'Recomendado: {min}–{max} noches',
      generate:    'Confirmar',
    },
    itin: {
      header:      'Itinerario',
      loading:     'Generando tu itinerario…',
      loadingHint: 'Esto tarda ~10 segundos',
    },
    session: {
      takenOver:    'Sesión reanudada en otro lugar',
      takenOverSub: 'Has abierto Plotted en otra pestaña o ventana. Esta sesión está en pausa.',
      resumeHere:   'Reanudar aquí',
    },

    home: {
      traveller:      'viajero',
      travellers:     'viajeros',
      flightHotel:    'vuelo + hotel',
      recalculate:    'Recalcular precios',
      myDests:        n => `Mis ${n} destinos`,
      mySlots:        n => `Mis ${n} ventanas`,
      computing:      'Calculando mejores precios…',
      loadingText:    'Plotted busca tus mejores opciones…',
      emptyPlan:      'Añade destinos a tu plan y fechas para ver el ranking',
      emptyNoDest:    'Explora el mapa para descubrir y añadir destinos',
      emptyCtaMap:    'Descubrir destinos',
      emptyNoPlan:    'Añade destinos a tu plan para ver el ranking',
      emptyCtaPlan:   'Mis destinos',
      emptyNoSlot:    'Sin fechas seleccionadas. ¿Quieres que añada puentes y festivos para empezar?',
      emptyCtaAutoSlot: 'Generar automáticamente',
      emptyCtaDest:   'Añade tu primer destino',
      emptyCtaSlot:   'Ir al calendario',
      showSlotBanner: 'Mostrar el calendario',
      emptyNoCompat:  (n) => `Ninguno de tus destinos encaja con tus ventanas (máx. ${n} noche${n>1?'s':''}). Prueba ventanas más largas o destinos más cercanos.`,
      emptyCtaLonger: 'Editar ventanas',
      emptyCtaCloser: 'Editar destinos',
      groupWeekend:   'Escapada',
      groupCitybreak: 'Viaje',
      groupVoyage:    'Grand Tour',
      share:          'Compartir',
      updatedNow:     'ahora mismo',
      updatedMins:    (n) => `hace ${n} min`,
      updatedHours:   (n) => `hace ${n}h`,
      updatedDays:    (n) => `hace ${n}d`,
      geoBlockedTitle: 'Localización no permitida',
      geoBlockedMsg:   'Las duraciones mínimas y el ranking se estiman desde París. Define tu aeropuerto de salida para recomendaciones precisas.',
      geoBlockedCta:   'Definir mi aeropuerto de salida',
      noSlotForDest:  'Ninguna ventana compatible para este destino',
      noDestForSlot:  'Ningún destino compatible para esta ventana',
      noFlightEvent:  'No se encontró vuelo para este evento. Comprueba tu aeropuerto de salida en Perfil.',
      helpText:       "Plotted conecta tus destinos con tus disponibilidades — o al revés. El ranking tiene en cuenta tus preferencias de viaje. Para los eventos, consideramos llegar hasta 3 días antes y volver al día siguiente.",
      shareCta:       n => `Comparte tu Top ${n}`,
      shareCtaSub:    'Que tus amigos descubran tus próximas aventuras',
      needsLongSlot:  'Período largo requerido',
      needsLongSlotSub: 'Añade un período largo o reduce las noches mín.',
      from:           'desde',
      arrival:        'Llegada',
      estimated:      'Precio estimado',
    },

    dest: {
      title:        'Mis destinos',
      helpText:     'Construye tu lista de sueños buscando por nombre o explorando el mapa. Plotted calcula los precios para tus ventanas de viaje y clasifica las mejores opciones para ti. Para empezar, hemos añadido tres destinos populares.',
      emptyTitle:   'Sin destinos',
      emptySub:     'Explora el mapa y añade los destinos y eventos que te inspiran.',
      add:          'Añadir',
      explore:      '🗺️ Explorar',
      filterAll:    'Todos',
      filterCity:   'Ciudad',
      filterNature: 'Escapada',
      filterEvent:  'Destacados',
      subAll:       'Todos',
      loading:      'Cargando',
      activePlan:   'Plan activo',
      planEmpty:    'Selecciona hasta {n} destinos para el ranking Top 5',
      place:        'lugar',
      places:       'lugares',
      addModalTitle:  'Añadir un destino',
      addModalSearch: 'Ciudad, país o evento…',
      addModalHint:   'Escribe al menos 2 caracteres — ciudad, país o evento.',
      addModalEmpty:  'Sin resultados',
      addModalSearching:  'Buscando…',
      addModalClose:      'Cerrar',
      addModalDoneN:      'Listo · {n} añadido(s)',
      addModalDidYouMean: 'Sin coincidencia exacta. ¿Quisiste decir:',
      addModalAdding:     'Añadiendo…',
      addModalAddFailed:  'No se pudo añadir. Inténtalo de nuevo.',
      addModalAdded:  '✓ Añadido',
      planAdd:      '+ Plan',
      planIn:       '✓ Plan',
      planFull:     'Completo',
      noSlotTitle:  'Sin franja compatible en tu plan',
      noSlotBody:   (dest, nights) => `${dest} requiere al menos ${nights} noches — ninguna franja de tu plan coincide. Añade una franja más larga o ajusta las noches mínimas.`,
      noSlotAdjust: 'Ajustar noches mínimas',
      noSlotCreate: 'Crear una franja',
    },

    cal: {
      title:       'Calendario',
      helpText:    'Indica tus ventanas de viaje — los festivos y puentes ya están incluidos, solo ajústalos a tu gusto. Añade períodos cortos para una escapada urbana, o más largos para una aventura lejana.',
      autoSlots:   '↺ Slots auto',
      slots:       'slots',
      nights:      'noches',
      loading:     'Cargando slots...',
      event:       'Evento',
      bridge:      'Puente',
      addSlot:          '+ Añadir un slot',
      slotLimitReached: 'Límite de slots alcanzado',
      chooseDep:   'Elige la fecha de salida',
      chooseRet:   'Elige la fecha de regreso',
      reset:       'Restablecer',
      addThisSlot: 'Añadir este slot',
      editSlot:    'Editar slot',
      customSlot:  'Personalizar slot',
      selectDep:   'Selecciona la salida',
      selectRet:   'Selecciona el regreso',
      delete:      '🗑 Eliminar',
      save:        'Guardar',
    },

    ob: {
      page0title: 'Del sueño al viaje. Sin escalas inútiles.',
      page0sub:   '',
      labelCity:   'Vibrar',
      labelNature: 'Reconectar',
      labelEvent:  'Desatar',
      page1title: 'Marca tus destinos. Solo eso.',
      page1sub:   '',
      page2title: '¿Cuándo os vais? Festivos y puentes incluidos.',
      page2sub:   '',
      page3title: 'Tus fechas. Tus destinos. Plotted.',
      page3sub:   '',
      calDays:    ['L','M','X','J','V','S','D'],
      calMonths:  ['ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'],
      continue:   'Continuar →',
      letsGo:     '¡Vamos!',
      skip:       'Omitir',
    },

    trip: {
      yourSelection:  'Tu selección',
      flight:         'Vuelo',
      hotel:          'Hotel',
      co2offset:      'Compensación CO₂',
      bookNow:        'Reservar — €{total}',
      sort:           'Ordenar:',
      sortBest:       '⭐ Mejor',
      sortPrice:      '💶 Precio',
      sortFastest:    '⚡ Más rápido',
      sortEco:        '🌿 Eco',
      sortRating:     '🏅 Valoración',
      sortDistance:   '📍 Distancia',
      flightsFound:   '{n} vuelos encontrados · {origin} → {city} · {date}',
      hotelsFound:    '{n} hoteles · {city} · {from} – {to} · {nights} noches',
      belowAvg:       '↓ {pct}% por debajo de la media histórica',
      historicAvg:    'Media histórica para este destino + fechas:',
      yourSaving:     'Tu ahorro:',
      flightAnalysis: 'Análisis del vuelo seleccionado',
      hotelReview:    'Desglose de valoraciones del hotel seleccionado',
      co2footprint:   '🌿 Huella de carbono',
      co2roundtrip:   '{co2}t CO₂ por este viaje de ida y vuelta',
      co2offsetCost:  'Compensación: €{cost} · donado a proyectos de reforestación certificados',
      greener:        '{pct}% más ecológico que la media para esta ruta',
      scorePrice:     'Precio',
      scoreDuration:  'Duración',
      scoreCo2:       'Eficiencia CO₂',
      scoreComfort:   'Confort y extras',
    },
    flight: {
      direct:     'DIRECTO',
      stop:       '1 ESCALA',
      bagIncl:    '🧳 Equipaje incl.',
      flexible:   '🔄 Flexible',
      seatsLeft:  '🔥 {n} plazas restantes',
      vsAvg:      '{n}% vs media',
      lowcost:    'Low-cost',
      alliance:   'alianza',
      selected:   '✓ Vuelo seleccionado',
    },
    hotel: {
      perNight:    '/noche',
      reviews:     'opiniones',
      fromCentre:  'km del centro',
      selected:    '✓ Hotel seleccionado',
    },

    save: { failed: 'No se pudieron guardar tus últimos cambios. Se conservan en este dispositivo — comprueba tu conexión.' },
    sub: {
      mockNotice:     'Demostración — no se cobra ningún pago ni se envían datos bancarios.',
      back:           '← Volver',
      activated:      '¡Suscripción activada!',
      contactDetails: 'Datos de contacto',
      paymentInfo:    'Datos de pago',
      email:          'Email',
      expiry:         'MM / AA',
      cardHolder:     'Nombre en la tarjeta',
      processing:     'Procesando…',
      payAmount:      'Pagar {amount}',
      perYear:        '/ año',
      perMonth:       '/ mes',
      planFree:    'Trotamundos',
      planSilver:  'Viajero',
      planGold:    'Explorador',
      headline:    'Plan Trotamundos: <b>Top 5</b> en 5 destinos y 5 franjas. Mejora tu plan para desbloquear más.',
      tagline:     'Para ir más lejos, elige tu plan:',
      monthly:     'Mensual',
      annual:      'Anual',
      perMonth:    '/ mes',
      perYear:     '/ año · ',
      subscribe:   'Suscribirse',
      currentPlan: 'Plan actual',
      activePlan:  '✓ Activo',
      downgradeLink: 'Volver al plan <i>Trotamundos</i>',
      silverFeats: ['10 destinos', '10 franjas de calendario', '10 itinerarios / mes'],
      goldFeats:   ['15 destinos', '15 franjas de calendario', '15 itinerarios / mes'],
    },

    map: {
      typeVille:    'Ciudad',
      typeNature:   'Naturaleza',
      typeIle:      'Islas',
      typeCote:     'Costas',
      typeEvent:    'Destacados',
      evtSport:     'Deporte',
      evtMusic:     'Música',
      evtCulture:   'Cultura',
      evtNature:    'Naturaleza',
      unknownEvent: 'Evento',

      contAmerique: 'América',
      contEurope:   'Europa',
      contAfrique:  'África',
      contMOrient:  'O.Medio',
      contAsie:     'Asia',
      contOceanie:  'Oceanía',

      filterCity:   'Ciudad',
      filterNature: 'Escapada',
      filterEvent:  'Destacados',
      filterSel:    'Mis dest.',

      back:         'Volver',
      title:        'Explorar',
      loading:      'Cargando…',
      dest1:        'destino',
      destN:        'destinos',
      statusEvents: 'eventos',

      inProgress:   'En curso',
      inDays:       'En {n}d',
      inMonths:     'En {n}mes',
      annualEvent:  '🔄 Evento anual',

      eventAdded:   '✓ Evento añadido',
      destAdded:    '✓ Destino añadido',
      addToEvents:  '+ Añadir',
      addToDests:   '+ Añadir',
      toast:        '✓ Añadido a tu selección',
      errorPrefix:  'Error: ',
    },

    downgrade: {
      destsTitle: 'Demasiados destinos',
      slotsTitle: 'Demasiados períodos',
      removeN:    'Elimina {n} más',
      remove:     'Eliminar',
      confirm:    'Confirmar',
      autoTrim:   'Reducir automáticamente',
      helpText:   'Plotted limita automáticamente el número de combinaciones mostradas para mantener una experiencia fluida. Puedes gestionarlo tú mismo, o dejar que Plotted lo haga — las opciones más antiguas se eliminarán primero.',
    },

    guide: {
      highlights:   'Imprescindible',
      hiddenGems:   'Secretos locales',
      bars:         'Mejores bares',
      restaurants:  'Restaurantes',
      loading:      'Generando guía…',
      by:           'Top 5 de',
      generatedBy:  'Generado por Plotted · vuelo + hotel',
    },

    about: {
      title:       'Acerca de Plotted',
      tagline:     'Porque los mejores viajes empiezan en un mapa.',
      p1:          'Plotted nació de una observación sencilla: encontrar el momento adecuado para viajar al mejor precio lleva una eternidad. Seguir vuelos, comparar fechas, buscar ofertas… es casi un segundo trabajo.',
      p2:          "Sueñas, guardas, olvidas. Plotted no olvida. Vigila, compara, te alerta — y cuando llega el momento, todo está ahí, en tu mapa.",
      p3:          "Porque las mejores oportunidades no duran. Un vuelo que baja, una temporada baja, una promo que desaparece en 48h — sin una herramienta dedicada, siempre te las pierdes.",
      p4:          "Plotted llena ese vacío. No es otro comparador. No es una lista estática. Es tu mapa personal que trabaja en silencio — y que habla cuando realmente importa.",
      p5:          "Tus destinos soñados merecen algo mejor que una pestaña olvidada en tu navegador.",
      teamTitle:   'Los Plotters',
      teamIntro:   'Somos cinco apasionados de los viajes, convaincidos de que explorar el mundo no debería ser cuestión de presupuesto ni de tiempo perdido buscando.',
      m1role:      'Fundador y Desarrollador',
      m1bio:       'Tuvo la idea, escribió el código. Convencido de que un buen mapa vale más que un largo discurso.',
      m2role:      'Diseño y Experiencia de usuario',
      m2bio:       'Ella da a Plotted su carácter visual. Cada pantalla está pensada para que navegar sea un placer.',
      m3role:      'Datos y Precios',
      m3bio:       "Los buenos precios no avisan. Él, sí. Mago del pricing online, FareHunter conoce los entresijos de las plataformas de viaje mejor que nadie.",
      m4role:      'Comunidad y Redes sociales',
      m4bio:       'Siempre entre dos vuelos, ella conecta Plotted con sus usuarios. Es ella a quien escuchas en las redes.',
      m5role:      'Contenido y Destinos',
      m5bio:       'Selecciona, documenta y narra cada destino. Nada entra en Plotted sin pasar por él.',
      contactTitle:'Hablemos de viajes',
      contactText: '¿Una idea, una sugerencia, un destino que recomendar? Leo todos los mensajes.',
    },

    nav: {
      home:   'plotted',
      dest:   'Dest.',
      map:    'Mapa',
      cal:    'Agenda',
      trips:  'Viajes',
      user:   'Perfil',
    },

    splash: {
      tagline1: 'Tus sueños, nuestra vigilancia.',
      tagline2: 'Porque las mejores ofertas no duran.',
      welcome:  'Bienvenido de nuevo',
    },
  },

  // ── 中文 (Simplified) ────────────────────────────────────────────────────────
  zh: {
    // ZH n'était pas fourni dans la demande — traduction à faire relire.
    brand: {
      tagline:      '精选，而非搜索引擎。',
      taglineShort: '精选，而非搜索',
      taglineAlt:   '别再搜索了，开始挑选吧。',
    },
    profile: {
      title:          '我的个人资料',
      yourProfile:    '您的资料',
      notFilled:      '未填写',
      completion:     '资料完整度',
      completionLow:  '完善您的资料以获得精准推荐',
      completionMid:  '再填写几项即可完成',

      personal:         '个人信息',
      travelers:        '旅客与出发',
      prefs:            '出行偏好',
      coTravel:         '同行旅伴',

      me:               '我',
      coTravelersLabel: '同行旅伴',
      paxTotal:         '共{n}名旅客',
      relation:         '关系',
      addTraveler:      '+ 添加旅伴',
      edit:             '编辑',
      remove:           '删除',
      relConjoint:      '伴侣',
      relEnfant:        '子女',
      relAmi:           '朋友',
      relAutre:         '其他',

      firstName:        '名',
      lastName:         '姓',
      email:            '邮箱',
      phone:            '手机',
      street:           '街道',
      postalCode:       '邮政编码',
      city:             '城市',
      country:          '国家',
      region:           '地区 / 州',
      birthDate:        '出生日期',
      passportNumber:   '护照号',
      passportExpiry:   '有效期至',
      passportCountry:  '签发国',
      departureAirports:'出发机场',
      lang:             '语言',
      langNote:         '默认为设备语言',

      phFirstName:      '伟',
      phLastName:       '王',
      phEmail:          'ni@shifan.com',
      phStreet:         '和平路12号',
      phPostal:         '100000',
      phCity:           '北京',
      phCountry:        '中国',
      phRegion:         '广东省…',
      phPassport:       'AB 123456',
      phDate:           '日 / 月 / 年',
      phAirportSearch:  '北京、上海、广州…',

      styleLabel:          '风格',
      groupLabel:          '同行',
      dailyBudgetLabel:    '预算 / 天 / 人',
      flightServicesLabel: '航班服务',
      hotelBudgetLabel:    '酒店预算 / 晚',
      hotelKeywordsLabel:  '酒店关键词',
      phHotelKeywords:     '宠物友好，含早餐…',
      flightClassLabel:         '舱位',
      flightClassNote:          '视供应情况而定',
      departureTimePrefLabel:   '出发时间',
      departureTimePrefNote:    '晚间J1 = 时段第一个晚上出发 · 早晨J2 = 次日早晨出发',

      phCoFirstName:  '芳',
      phCoEmail:      'fang@shifan.com',
      shareTrip:      '共享出行信息',
      shareTripSub:   '接收相同的确认邮件',

      referralSection:  '推荐好友',
      referralLink:     '您的推荐链接',
      referralCopy:     '复制',
      referralCopied:   '已复制！',
      referralShare:    '分享',
      referralStats:    '已邀请{n}位好友 · 已获得{w}周旅行者',
      referralBonus:    '🎁 您和好友各获2周旅行者',
      referralHelp:     '与朋友分享 Plotted，解锁更多精彩目的地。',
      shareTopN:        '分享我的Top 5',
      shareTopNCopied:  '链接已复制！',
      shareTopNBtn:     '复制链接',
      shareTopNCreating:'正在创建链接…',
      // share modal
      shareModalTitle:  '分享我的目的地',
      shareModalReady:  '你的 Plotted 卡片已准备好！✨',
      shareModalReadyTrip: '你的分享已准备好！✈️',
      shareModalCount:  n => `${n} 个优先目的地 · `,
      shareModalTotal:  n => `共 ${n} 个`,
      shareModalShare:  '分享',
      shareModalCopyLink: '🔗 复制链接',
      shareModalCopied: '✓ 链接已复制！',
      // share view (public page)
      shareViewCta:         '注册',
      shareViewCtaTrip:     '旅行日记',
      shareViewExpired:     '链接已过期或无效',
      shareViewCtaCard:     n => `已有 Top ${n}`,
      shareViewCtaCardAnon: '你的 Top 5 是什么？',
      shareViewCtaYou:      '你呢？',
      shareViewCtaBody:     'Plotted 根据你的日期、预算和偏好推荐最佳目的地。',
      shareViewCtaBtn:      '免费创建我的 Top 5 →',
      shareViewCtaSub:      '免费 · 无需信用卡 · 2分钟',
      shareViewBucketList:  '愿望清单',
      shareViewTopNOf:      (n, name) => name ? `${name} 的 Top ${n}` : `我的 Top ${n}`,
      shareViewFlights:     '航班选项',
      shareViewFlight:      '航班',
      shareViewHotel:       '酒店',
      shareViewTotal:       '总费用',
      shareViewDirect:      '直飞',
      shareViewStop:        n => `${n} 次中转`,
      shareViewDep:         '出发',
      shareViewArr:         '到达',
      shareViewEstimated:   '预估价格',
      shareViewFreeCancel:  '免费取消',
      shareViewHighlights:  '必看景点',
      shareViewHiddenGems:  '当地秘境',
      shareViewBars:        '最佳酒吧',
      shareViewRestaurants: '餐厅',
      shareViewGuide:       '攻略',
      shareViewTripOf:      name => name ? `${name} 的旅行` : '我的旅行',
      shareViewTripTo:      dest => dest ? `前往${dest}的旅行` : '我的旅行',
      shareViewSlotsOf:     name => name ? `${name} 的航班` : '航班选项',
      shareViewFrom:        '起价',
      shareViewPracticalTitle:  '实用信息',
      shareViewNoteTitle:       '备注',
      shareViewPhrasebookTitle: '实用词汇',
      shareViewLabelCurrency:   '货币',
      shareViewLabelPhone:      '电话区号',
      shareViewLabelElectricity:'电压/插座',
      shareViewLabelLanguage:   '语言',
      shareViewLabelTimezone:   '时区',
      shareViewLabelWater:      '自来水',
      shareViewLabelTipping:    '小费',
      shareViewLabelHolidays:   '节假日',
      shareViewLabelSales:      '打折季',
      shareViewItineraryTitle:  '行程',
      shareViewDay:             n => `第${n}天`,
      shareViewMorning:         '上午',
      shareViewLunch:           '午餐',
      shareViewAfternoon:       '下午',
      shareViewEvening:         '夜生活',
      shareViewDinner:          '晚餐',
      socialCardTitle:  '我的下一次旅行',
      socialCardShare:  '分享',
      changePassword: '修改密码',
      settings:       '设置',
      phCurrentPwd:   '当前密码',
      phNewPwd:       '新密码',
      phConfirmPwd:   '确认密码',
      confirm:        '确认',
      save:           '保存',
      signOut:        '退出登录',
      deleteAccount:        '删除我的账户',
      deleteAccountConfirm: '此操作不可逆。您的所有数据将被永久删除。',
      deleteAccountBtn:     '确认删除',
      deleteAccountCancel:  '取消',
      deleteAccountDone:    '账户已删除。',
      deleteAccountError:   '删除失败。请重试或联系客服。',

      pwdEnterCurrent: '请输入当前密码',
      pwdMin8:         '最少8个字符',
      pwdNoMatch:      '密码不一致',
      pwdWrongCurrent: '当前密码不正确',
      pwdUpdated:      '密码已更新',

      holidayCountry:     '参考国家 · 公共假期',
      holidayCountryNote: '点击日历中的"↺ 自动时段"重新计算。',
      holidayCountryAuto: '默认：从浏览器自动检测。',
      autoPrefix:         '自动 —',
      appLang:            '应用语言',
      soon:               '（即将推出）',
      detectedLang:       '检测到的语言：',
      searchMode:         '搜索模式',
      flightOnly:         '仅机票',
      flightAndHotel:     '机票 + 酒店',
      replayOnboarding:   '重新查看教程',
      about:              '关于',

      // subscription management
      accountSection:  '账户管理',
      planLabel:       '当前方案',
      subscribedOn:    '订阅日期',
      renewalOn:       '续订日期',
      managePlan:      '管理订阅',
      freePlanDesc:    '免费',
    },

    auth: {
      forgotTitle:  '忘记密码',
      loginTitle:   '欢迎回来',
      signupTitle:  '创建账户',
      forgotSub:    '输入您的邮箱以接收重置链接',
      loginSub:     '登录以继续您的旅程',
      signupSub:    '加入 Plotted，探索世界',
      resetSent:    '重置链接已发送至',
      checkEmail:   '请检查您的邮箱以确认账户。',
      phPassword:   '密码',
      forgotLink:   '忘记密码？',
      sendLink:     '发送链接',
      signIn:       '登录',
      signUp:       '注册',
      backToLogin:  '← 返回登录',
      orWith:       '或通过以下方式继续',
      googleBtn:    '通过 Google 继续',
      magicBtn:     '发送魔法链接',
      magicSent:    '链接已发送 — 请查看您的邮箱。',
      noAccount:    '没有账户？',
      haveAccount:  '已有账户？',
      terms:        '继续即表示您同意我们的使用条款',
    },

    common: {
      howItWorks: '如何使用？',
      understood: '明白了',
      cancel:     '取消',
      back:       '‹ 返回',
      night:      '晚',
      nights:     '晚',
    },
    nightpicker: {
      title:       '住宿天数',
      recommended: '推荐：{min}–{max}晚',
      generate:    '确认',
    },
    itin: {
      header:      '行程',
      loading:     '正在生成您的行程…',
      loadingHint: '大约需要10秒',
    },
    session: {
      takenOver:    '已在其他地方继续会话',
      takenOverSub: '您在另一个标签页或窗口中打开了 Plotted。此会话已暂停。',
      resumeHere:   '在此继续',
    },

    home: {
      traveller:      '旅客',
      travellers:     '旅客',
      flightHotel:    '机票 + 酒店',
      recalculate:    '重新计算价格',
      myDests:        n => `我的${n}个目的地`,
      mySlots:        n => `我的${n}个时段`,
      computing:      '正在计算最优价格…',
      loadingText:    'Plotted 正在寻找最佳选项…',
      emptyPlan:      '将目的地添加到计划并设置日期以查看排名',
      emptyNoDest:    '探索地图发现并添加目的地',
      emptyCtaMap:    '发现目的地',
      emptyNoPlan:    '将目的地加入计划以查看排名',
      emptyCtaPlan:   '我的目的地',
      emptyNoSlot:    '未选择日期。要自动添加节假日和连休日期来开始吗？',
      emptyCtaAutoSlot: '自动生成',
      emptyCtaDest:   '添加第一个目的地',
      emptyCtaSlot:   '前往日历',
      showSlotBanner: '显示日历',
      emptyNoCompat:  (n) => `没有目的地与你的时间段匹配（最多${n}晚）。请尝试更长的时间段或更近的目的地。`,
      emptyCtaLonger: '修改时间段',
      emptyCtaCloser: '修改目的地',
      groupWeekend:   '短途出行',
      groupCitybreak: '旅程',
      groupVoyage:    'Grand Tour',
      share:          '分享',
      updatedNow:     '刚刚',
      updatedMins:    (n) => `${n}分钟前`,
      updatedHours:   (n) => `${n}小时前`,
      updatedDays:    (n) => `${n}天前`,
      geoBlockedTitle: '位置访问被拒绝',
      geoBlockedMsg:   '最短行程和排名基于巴黎估算。请设置您的出发机场以获得准确推荐。',
      geoBlockedCta:   '设置出发机场',
      noSlotForDest:  '该目的地暂无匹配时段',
      noDestForSlot:  '该时段暂无匹配目的地',
      noFlightEvent:  '未找到该活动的航班。请在个人资料中检查出发机场。',
      helpText:       'Plotted 将您的目的地与可用日期匹配——反之亦然。排名综合考虑您的出行偏好。对于活动，我们考虑提前最多3天抵达，次日返回。',
      shareCta:       n => `分享你的Top ${n}`,
      shareCtaSub:    '让朋友发现你即将到来的冒险',
      needsLongSlot:  '需要长假期',
      needsLongSlotSub: '添加长假期或减少最少晚数',
      from:           '起价',
      arrival:        '抵达',
      estimated:      '预估价格',
    },

    dest: {
      title:        '我的目的地',
      helpText:     '通过搜索名称或浏览地图来构建您的心愿单。Plotted 为您的出行时段计算价格并排出最佳选择。我们已为您添加了三个热门目的地作为起点。',
      emptyTitle:   '暂无目的地',
      emptySub:     '探索地图，添加激发您灵感的目的地和活动。',
      add:          '添加',
      explore:      '🗺️ 探索',
      filterAll:    '全部',
      filterCity:   '城市',
      filterNature: '自然',
      filterEvent:  '精选活动',
      subAll:       '全部',
      loading:      '加载中',
      activePlan:   '当前计划',
      planEmpty:    '最多选择 {n} 个目的地参与 Top 5 排名',
      place:        '个地点',
      places:       '个地点',
      addModalTitle:  '添加目的地',
      addModalSearch: '城市、国家或活动…',
      addModalHint:   '请输入至少 2 个字符 — 城市、国家或活动。',
      addModalEmpty:  '无结果',
      addModalSearching:  '搜索中…',
      addModalClose:      '关闭',
      addModalDoneN:      '完成 · 已添加 {n} 个',
      addModalDidYouMean: '没有完全匹配。您是否想找：',
      addModalAdding:     '正在添加…',
      addModalAddFailed:  '添加失败，请重试。',
      addModalAdded:  '✓ 已添加',
      planAdd:      '+ 计划',
      planIn:       '✓ 计划',
      planFull:     '已满',
      noSlotTitle:  '计划中无兼容时间段',
      noSlotBody:   (dest, nights) => `${dest} 至少需要 ${nights} 晚——计划中的时间段均不匹配。请添加更长的时间段或调整最少晚数。`,
      noSlotAdjust: '调整最少晚数',
      noSlotCreate: '创建时间段',
    },

    cal: {
      title:       '日历',
      helpText:    '设置您的潜在出行时段——公众假期和长周末已自动包含，按需调整即可。添加短时段适合城市短游，或更长时段适合远途冒险。',
      autoSlots:   '↺ 自动时段',
      slots:       '个时段',
      nights:      '晚',
      loading:     '加载时段中...',
      event:       '活动',
      bridge:      '小长假',
      addSlot:          '+ 添加时段',
      slotLimitReached: '已达时段上限',
      chooseDep:   '选择出发日期',
      chooseRet:   '选择返回日期',
      reset:       '重置',
      addThisSlot: '添加此时段',
      editSlot:    '编辑时段',
      customSlot:  '自定义时段',
      selectDep:   '选择出发',
      selectRet:   '选择返回',
      delete:      '🗑 删除',
      save:        '保存',
    },

    ob: {
      page0title: '从梦想到旅途。告别多余中转。',
      page0sub:   '',
      labelCity:   '律动',
      labelNature: '归野',
      labelEvent:  '狂欢',
      page1title: '标记你的目的地。就这样。',
      page1sub:   '',
      page2title: '什么时候出发？假期与连休均已包含。',
      page2sub:   '',
      page3title: '你的日期。你的目的地。Plotted。',
      page3sub:   '',
      calDays:    ['一','二','三','四','五','六','日'],
      calMonths:  ['一月','二月','三月','四月','五月','六月','七月','八月','九月','十月','十一月','十二月'],
      continue:   '继续 →',
      letsGo:     '出发！',
      skip:       '跳过',
    },

    trip: {
      yourSelection:  '您的选择',
      flight:         '航班',
      hotel:          '酒店',
      co2offset:      '碳补偿',
      bookNow:        '立即预订 — €{total}',
      sort:           '排序：',
      sortBest:       '⭐ 最佳',
      sortPrice:      '💶 价格',
      sortFastest:    '⚡ 最快',
      sortEco:        '🌿 环保',
      sortRating:     '🏅 评分',
      sortDistance:   '📍 距离',
      flightsFound:   '找到 {n} 个航班 · {origin} → {city} · {date}',
      hotelsFound:    '{n} 家酒店 · {city} · {from} – {to} · {nights}晚',
      belowAvg:       '↓ 低于历史均价 {pct}%',
      historicAvg:    '该目的地+日期历史均价：',
      yourSaving:     '您的节省：',
      flightAnalysis: '已选航班分析',
      hotelReview:    '已选酒店评分详情',
      co2footprint:   '🌿 碳排放',
      co2roundtrip:   '本次往返 {co2}t CO₂',
      co2offsetCost:  '补偿费用：€{cost} · 捐赠至认证再造林项目',
      greener:        '比该路线平均水平低 {pct}%',
      scorePrice:     '价格',
      scoreDuration:  '时长',
      scoreCo2:       'CO₂效率',
      scoreComfort:   '舒适度与附加项',
    },
    flight: {
      direct:     '直飞',
      stop:       '1次转机',
      bagIncl:    '🧳 含行李',
      flexible:   '🔄 可改签',
      seatsLeft:  '🔥 剩{n}席',
      vsAvg:      '{n}% vs均值',
      lowcost:    '低成本',
      alliance:   '联盟',
      selected:   '✓ 已选此航班',
    },
    hotel: {
      perNight:    '/晚',
      reviews:     '条评价',
      fromCentre:  'km距市中心',
      selected:    '✓ 已选此酒店',
    },

    save: { failed: '最近的修改未能保存。已暂存在本设备上 — 请检查网络连接。' },
    sub: {
      mockNotice:     '演示 — 不会扣款，也不会发送任何银行卡信息。',
      back:           '← 返回',
      activated:      '订阅已激活！',
      contactDetails: '联系方式',
      paymentInfo:    '支付信息',
      email:          '邮箱',
      expiry:         '月 / 年',
      cardHolder:     '持卡人姓名',
      processing:     '处理中…',
      payAmount:      '支付 {amount}',
      perYear:        '/ 年',
      perMonth:       '/ 月',
      planFree:    '旅人',
      planSilver:  '旅行者',
      planGold:    '探索家',
      headline:    '旅人版：5个目的地、5个时段的<b>Top 5</b>。升级解锁更多。',
      tagline:     '想要更多？选择您的方案：',
      monthly:     '按月',
      annual:      '按年',
      perMonth:    '/ 月',
      perYear:     '/ 年 · ',
      subscribe:   '立即订阅',
      currentPlan: '当前方案',
      activePlan:  '✓ 当前',
      downgradeLink: '切换至旅人方案',
      silverFeats: ['10个目的地', '10个日历时段', '每月10条行程'],
      goldFeats:   ['15个目的地', '15个日历时段', '每月15条行程'],
    },

    map: {
      typeVille:    '城市',
      typeNature:   '自然',
      typeIle:      '岛屿',
      typeCote:     '海岸',
      typeEvent:    '精选活动',
      evtSport:     '体育',
      evtMusic:     '音乐',
      evtCulture:   '文化',
      evtNature:    '自然',
      unknownEvent: '活动',

      contAmerique: '美洲',
      contEurope:   '欧洲',
      contAfrique:  '非洲',
      contMOrient:  '中东',
      contAsie:     '亚洲',
      contOceanie:  '大洋洲',

      filterCity:   '城市',
      filterNature: '自然',
      filterEvent:  '精选',
      filterSel:    '我的',

      back:         '返回',
      title:        '探索',
      loading:      '加载中…',
      dest1:        '个目的地',
      destN:        '个目的地',
      statusEvents: '个活动',

      inProgress:   '进行中',
      inDays:       '{n}天后',
      inMonths:     '{n}个月后',
      annualEvent:  '🔄 年度活动',

      eventAdded:   '✓ 活动已添加',
      destAdded:    '✓ 目的地已添加',
      addToEvents:  '+ 添加',
      addToDests:   '+ 添加',
      toast:        '✓ 已添加到您的选择',
      errorPrefix:  '错误：',
    },

    downgrade: {
      destsTitle: '目的地过多',
      slotsTitle: '时间段过多',
      removeN:    '再删除 {n} 个',
      remove:     '删除',
      confirm:    '确认',
      autoTrim:   '自动精简',
      helpText:   'Plotted 会自动限制显示的组合数量以保持流畅体验。您可以自行管理，也可以让 Plotted 处理——最早添加的选项将优先被删除。',
    },

    guide: {
      highlights:   '必游景点',
      hiddenGems:   '本地秘境',
      bars:         '最佳酒吧',
      restaurants:  '餐厅推荐',
      loading:      '正在生成攻略…',
      by:           '的Top 5',
      generatedBy:  '由 Plotted 生成 · 机票 + 酒店',
    },

    about: {
      title:       '关于 Plotted',
      tagline:     '因为最美好的旅程从一张地图开始。',
      p1:          'Plotted 诞生于一个简单的发现：在最佳价格下找到合适的出行时机需要花费大量时间。追踪航班、比较时段、等待优惠……几乎是一份第二职业。',
      p2:          '你憧憬、你收藏、你遗忘。Plotted 不会遗忘。它监测、比较、提醒你——当时机到来时，一切都在你的地图上。',
      p3:          '因为最好的机会不会等待。一个降价航班、一段淡季、一个48小时内消失的优惠——没有专用工具，你永远会错过。',
      p4:          'Plotted 填补了这个空白。它不是又一个比价网站，不是一份静态清单。它是你的个人地图，默默工作——在真正重要的时候开口说话。',
      p5:          '你梦想中的目的地，值得比浏览器里一个被遗忘的标签页更好的待遇。',
      teamTitle:   'Plotters 团队',
      teamIntro:   '我们是五位旅行爱好者，坚信探索世界不应该是预算或浪费时间搜索的问题。',
      m1role:      '创始人 & 开发者',
      m1bio:       '他有了这个想法，他写了代码。坚信一张美丽的地图胜过长篇大论。',
      m2role:      '设计 & 用户体验',
      m2bio:       '她赋予 Plotted 独特的视觉风格。每个界面都经过精心设计，让浏览成为一种享受。',
      m3role:      '数据 & 价格',
      m3bio:       '好价格从不提前打招呼，但他会。FareHunter 是在线定价领域的高手，对各大旅行平台的运作机制了如指掌。',
      m4role:      '社区 & 社交媒体',
      m4bio:       '总是在两次航班之间，她连接 Plotted 与用户。社交媒体上那个声音就是她。',
      m5role:      '内容 & 目的地',
      m5bio:       '他挑选、记录并讲述每个目的地的故事。没有经过他，什么都不会进入 Plotted。',
      contactTitle:'聊聊旅行',
      contactText: '有想法、建议或想推荐的目的地？我阅读每一条消息。',
    },

    nav: {
      home:   'plotted',
      dest:   '目的地',
      map:    '地图',
      cal:    '日历',
      trips:  '行程',
      user:   '我的',
    },

    splash: {
      tagline1: '您的梦想，我们的守望。',
      tagline2: '因为最好的机会稍纵即逝。',
      welcome:  '欢迎回来',
    },
  },
};

// ─── Hook ─────────────────────────────────────────────────────────────────────
// Usage: const t = useT(travelPrefs?.appLang);
//        t('profile.title')  →  'Mon profil' | 'My profile' | …
//
// Falls back to FR if lang not found; returns the key itself if key not found.

// Key used to persist language choice before the user has a Supabase profile.
export const LANG_STORAGE_KEY = 'plotted_lang';

export const LANG_OPTIONS = [
  { code:'fr', flag:'🇫🇷', label:'Français' },
  { code:'en', flag:'🌐',  label:'English'  },
  { code:'es', flag:'🇪🇸', label:'Español'  },
  { code:'zh', flag:'🇨🇳', label:'中文'     },
];

// Static translation helper for non-hook contexts (e.g. ShareView)
export function tShare(lang, key) {
  const dict = translations[lang] || translations.fr;
  const parts = key.split('.');
  let val = dict;
  for (const p of parts) val = val?.[p];
  return val ?? key;
}

export function useT(appLang) {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem(LANG_STORAGE_KEY) : null;
  const lang = (appLang || stored || (navigator.language || 'fr').split('-')[0]).toLowerCase();
  const dict = translations[lang] || translations.fr;
  return function t(key) {
    const parts = key.split('.');
    let val = dict;
    for (const p of parts) val = val?.[p];
    return val ?? key;
  };
}
